import React from 'react';

export const ZendeskSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="#03363D" />
			<path
				d="M15.4789 12.465V23.1153H6.65747L15.4789 12.465ZM15.4789 8.64319C15.4789 9.81298 15.0142 10.9349 14.187 11.762C13.3598 12.5892 12.238 13.0539 11.0682 13.0539C9.89838 13.0539 8.7765 12.5892 7.94933 11.762C7.12217 10.9349 6.65747 9.81298 6.65747 8.64319H15.4789ZM16.9321 23.1162C16.9321 21.9464 17.3968 20.8245 18.224 19.9974C19.0511 19.1702 20.173 18.7055 21.3428 18.7055C22.5126 18.7055 23.6345 19.1702 24.4616 19.9974C25.2888 20.8245 25.7535 21.9464 25.7535 23.1162H16.9321ZM16.9321 19.2943V8.64319H25.7554L16.9321 19.2934V19.2943Z"
				fill="white"
			/>
		</svg>
	);
};
